
import { ReactNode, useEffect } from "react";
import { Box, Fab, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Background from '../../images/wordcollage_shadow_light.avif'
import { useLocation } from "react-router";
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';

const useStyles = makeStyles()((theme) => ({
 body: {
    flex: 1,
    overflow: 'auto',
    minHeight: '100vh',
 },
}))

export default function AppBody(props: { children: ReactNode }) {
  const { classes } = useStyles();
  const location = useLocation();
  const isLoginPage = /\/login\/?$/.test(location.pathname);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Box className={classes.body}>
      {props.children}
      {!isLoginPage && (
        <Fab 
          sx={{
            position: 'fixed',
            bottom: {xs: 20, md: 70},
            right: 20,
            zIndex: 10,
            opacity: 0.9
          }} 
          variant="extended" 
          color="primary"
          onClick={() => window.open('https://order.toasttab.com/egiftcards/gyrosa-102-1517-admirals-road', '_blank')}
        >

          <CardGiftcardIcon sx={{color: 'white'}}/>
          &nbsp;
          <Typography variant='h4' sx={{color: 'white', fontSize: '14px', textAlign: 'center', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)'}}>
            Gift Cards Available!
          </Typography>
        </Fab>
      )}
    </Box>
  );
}